module.exports = "<div class=\"container\">\n  <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 179
// module chunks = 1